import React from 'react';
import Link from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function ExternalLink({ href, children }) {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener"
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if (href) window.open(href, '_blank', 'noopener,noreferrer');
      }}
      onMouseDown={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
    >
      {children}
      <OpenInNewIcon sx={{ fontSize: 16, ml: 0.2, verticalAlign: 'middle' }} />
    </Link>
  );
}
